/**
 * To add blog posts, create new files in this directory and import them here and add them to the array below.
 */
import a_guide_on_window_treatments from "./a-guide-on-window-treatments";
import sunscreen_shades from "./sunscreen-shades";
import ordering_reverse_roll_shades from "./ordering-reverse-roll-shades";
import the_difference_between_Blinds_and_Shades from "./the-difference-between-Blinds-and-Shades";
import budget_friendly_window_shade_options from "./budget-friendly-window-shade-options";
import when_to_motorize_shades from "./when-to-motorize-shades";
import right_shades_for_your_window from "./right-shades-for-your-windows";
import best_home_skylight_roller_shades from "./best-home-skylight-roller-shades";
import choose_bottom_up_shades from "./choose-bottom-up-shades";
import choose_graphic_shades from "./choose-graphic-shades";

const blogPosts = [
	a_guide_on_window_treatments,
	sunscreen_shades,
	ordering_reverse_roll_shades,
	the_difference_between_Blinds_and_Shades,
	budget_friendly_window_shade_options,
	when_to_motorize_shades,
	right_shades_for_your_window,
	best_home_skylight_roller_shades,
	choose_bottom_up_shades,
	choose_graphic_shades,
];

export default blogPosts;
